import { createContext } from 'libs/createContext'
import feedbackIndexReducer, { initialState } from './reducer'
export { useActions as useFeedbackIndexActions } from './reducer'

export const { Provider: FilterGroupProvider, context: filterGroupContext } = createContext(
  initialState,
  feedbackIndexReducer
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/FilterGroup/context/index.js